// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.link--base-red--dark{
  color:#A70D00;
}
.cancel-fix {
  position: relative;
  top: -7px;
  text-decoration: underline;
}

.link--base-green:hover {
  text-decoration:none !important;
}

 .nav-bar {
  max-width: 1380px;
  margin-bottom: 10px;
}

.app-container {
  max-width: 1380px;
  padding-left: 2px;
  padding-right: 2px;
}

.form-row > [class*=col-] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}

.ng-invalid:not(form, .form-group, .ng-untouched) {
  border:none;
}

.circle {
  width: 25px;
  line-height: 26px;
  border-radius: 50%;
  text-align: center;
  background-color: #077a07;
  color: white;
  display: inline-block;
  margin-right: 10px;
  font-size: 16px;
  zoom: .9;
}

legend {
  border: none;
  color: #404040;
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
  position: static;
  width: 100%;
}

label {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 100%;
  display: block;
}

.note {
  font-size: 14px;
  color: black;
  position: relative;
  top: -1px;
  float: right;
  font-weight: 500;
}

.note .approved {
  color:#5BB900ed;
  font-weight:bold;
}

.note .draft {
  color:#FFBA52;
  font-weight:bold;
}

.note .cancelled {
  color:#9EA274;
  font-weight:bold;
}

.email-sent {
  margin-left: 10px;
}

.owl-dt-container-disabled, .owl-dt-trigger-disabled {
  opacity: 1;
  filter: Alpha(Opacity = 1);
  background-image: none;
  cursor: default !important;
}

@media (max-width: 900px) {
  .note {
    float: left;
    left: 5px;
    width: 100%;
    margin-top: 10px;
  }
  .email-sent {
    display: block;
    float: left;
    width: 100%;
    margin-left: 0px;
  }
}

@media (min-width: 992px) {
  .col-lg-1-5 {
    flex: 0 0 12.5%;
    max-width: 12.5%;
  }
  .col-lg-4-5 {
    flex: 0 0 37.333333%;
    max-width: 37.333333%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/new-order-page/new-order-page.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;AACjC;;CAEC;EACC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE;IACE,WAAW;IACX,SAAS;IACT,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IAEE,eAAe;IACf,gBAAgB;EAClB;EACA;IAEE,oBAAoB;IACpB,qBAAqB;EACvB;AACF","sourcesContent":[".link--base-red--dark{\n  color:#A70D00;\n}\n.cancel-fix {\n  position: relative;\n  top: -7px;\n  text-decoration: underline;\n}\n\n.link--base-green:hover {\n  text-decoration:none !important;\n}\n\n .nav-bar {\n  max-width: 1380px;\n  margin-bottom: 10px;\n}\n\n.app-container {\n  max-width: 1380px;\n  padding-left: 2px;\n  padding-right: 2px;\n}\n\n.form-row > [class*=col-] {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.form-row {\n  display: flex;\n  flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n\n.ng-invalid:not(form, .form-group, .ng-untouched) {\n  border:none;\n}\n\n.circle {\n  width: 25px;\n  line-height: 26px;\n  border-radius: 50%;\n  text-align: center;\n  background-color: #077a07;\n  color: white;\n  display: inline-block;\n  margin-right: 10px;\n  font-size: 16px;\n  zoom: .9;\n}\n\nlegend {\n  border: none;\n  color: #404040;\n  font-size: 18px;\n  font-weight: bold;\n  padding-bottom: 5px;\n  position: static;\n  width: 100%;\n}\n\nlabel {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: 100%;\n  display: block;\n}\n\n.note {\n  font-size: 14px;\n  color: black;\n  position: relative;\n  top: -1px;\n  float: right;\n  font-weight: 500;\n}\n\n.note .approved {\n  color:#5BB900ed;\n  font-weight:bold;\n}\n\n.note .draft {\n  color:#FFBA52;\n  font-weight:bold;\n}\n\n.note .cancelled {\n  color:#9EA274;\n  font-weight:bold;\n}\n\n.email-sent {\n  margin-left: 10px;\n}\n\n.owl-dt-container-disabled, .owl-dt-trigger-disabled {\n  opacity: 1;\n  filter: Alpha(Opacity = 1);\n  background-image: none;\n  cursor: default !important;\n}\n\n@media (max-width: 900px) {\n  .note {\n    float: left;\n    left: 5px;\n    width: 100%;\n    margin-top: 10px;\n  }\n  .email-sent {\n    display: block;\n    float: left;\n    width: 100%;\n    margin-left: 0px;\n  }\n}\n\n@media (min-width: 992px) {\n  .col-lg-1-5 {\n    -ms-flex: 0 0 12.5%;\n    flex: 0 0 12.5%;\n    max-width: 12.5%;\n  }\n  .col-lg-4-5 {\n    -ms-flex: 0 0 37.333333%;\n    flex: 0 0 37.333333%;\n    max-width: 37.333333%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
